import React, { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Outlet } from "react-router-dom";

import { RECAPTCHA_KEY } from "./Configurations";
import checkMaintenanceMode from "./MaintenanceModeUtil";
import Layout from "./pods/components/layout/Layout";

function App() {
  useEffect(() => {
    checkMaintenanceMode();
  }, []);

  return (
    <Layout>
      <Layout.Nav/>
      <Layout.Body>
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
          <Outlet />
        </GoogleReCaptchaProvider>
      </Layout.Body>
    </Layout>
  );
}

export default App;
